import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var AvatarTheme = function (theme) {
    var _a;
    return ({
        defaultProps: {},
        styleOverrides: {
            root: {
                backgroundColor: theme.palette.greySecondary[300],
                '.MuiAvatarGroup-root &': {
                    '&.MuiAvatar-colorDefault': (_a = {
                            fontSize: theme.typography.body4.fontSize
                        },
                        _a[breakpoints.down('sm')] = {
                            fontSize: "0.625rem", //10
                        },
                        _a.fontWeight = "bold",
                        _a),
                },
            },
            fallback: {
                width: "100%",
                height: "100%",
                fill: theme.palette.greySecondary[500],
                backgroundColor: theme.palette.common.white,
                borderRadius: "100%",
                path: {
                    d: "path(\"M12 24A12 12 0 0 1 3.515 3.515a12 12 0 1 1 16.97 16.97A11.922 11.922 0 0 1 12 24zM9.24 12.278C6.006 13.034 6 15.331 6 17.99V18h12c0-2.664 0-4.965-3.234-5.718a3.738 3.738 0 0 1-5.527 0zM12 6a3.006 3.006 0 1 0 3 3.006A3 3 0 0 0 12 6z\" )",
                },
            },
        },
    });
};
export default AvatarTheme;
//# sourceMappingURL=theme.js.map